<div class="container-loading">
  <div class="heading text-center">
    <span>Please wait...</span>
    <div *ngIf="loginPurpose"><strong>Your personalized fundraiser is being created.</strong></div>
    <div *ngIf="!loginPurpose"><strong>Logging you in</strong></div>
  </div>
  <div class="lds-spinner">
    <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
  </div>
</div>